import * as Yup from 'yup';

export default Yup.object().shape({
  contract: Yup.object().nullable().required('El contrato es requerido')
});
